import { COUNTRY_ALIASES } from '../../../../countries/index.js';

/**
 * Search-only guesses: good enough to read "suppliers in korea" as South
 * Korea, too loose to normalise stored data with — which is why they are not
 * in the shared `COUNTRY_ALIASES`. Keys must be lowercase.
 */
const SEARCH_ONLY_COUNTRY_ALIASES: Record<string, string> = {
  korea: 'KR',
  congo: 'CG',
  drc: 'CD',
  prc: 'CN',
  dubai: 'AE',
  'abu dhabi': 'AE',
  türkiye: 'TR',
};

/**
 * Everyday country names that differ from the canonical `countryNameEn` —
 * users type "vietnam", not "Viet Nam". The shared aliases plus the
 * search-only ones above.
 *
 * Bare two-letter codes are excluded on purpose: fifteen of them are also
 * legal-entity suffixes, so "acme sa" would resolve to Saudi Arabia.
 */
export const COUNTRY_ALIASES_FOR_SEARCH: Record<string, string> = {
  ...COUNTRY_ALIASES,
  ...SEARCH_ONLY_COUNTRY_ALIASES,
};
